/**
 * <pre>
 * Goal enums.
 *
 * Summary of responsibilities:
 *
 *  - enumerate any commonly used values
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Goal
 * @namespace
 *
 * @type {Object}
 */
const Enums = {

	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
	/* Goal type. */

	// Number target (no end date, can take as long as required to reach goal).
	GOAL_TYPE_NUMBER: 						'type.metric.goal.number',
	// Just has an end date target (see how many participants we can get before the end).
	GOAL_TYPE_DATE: 						'type.metric.goal.date',
	// A number and a date target (see if we can reach the target before the end date).
	GOAL_TYPE_DATENUMBER: 					'type.metric.goal.datenumber',

	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
	/* Milestone strategy. */

	// No milestones.
	GOAL_MILESTONE_STRATEGY_TARGET: 		'strategy.metric.target',
	// Milestones for display purposes only.
	GOAL_MILESTONE_STRATEGY_MILESTONE: 		'strategy.metric.milestone',
	// Milestones act as gates based on datetime/limit.
	GOAL_MILESTONE_STRATEGY_GATEDMILESTONE: 'strategy.metric.timemilestone',

	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
	/* Overflow strategy. */

	// No overflow allowed.
	GOAL_EXCEED_STRATEGY_DISALLOW: 			'strategy.overflow.notallowed',
	// Overflow allowed.
	GOAL_EXCEED_STRATEGY_ALLOW: 			'strategy.overflow.allowed',

	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
	/* Fraud strategy. */

	// No fraud prevention.
	GOAL_FRAUD_STRATEGY_NONE: 				'strategy.fraud.none',
	// Always present Captcha overlay.
	GOAL_FRAUD_STRATEGY_CAPTCHA: 			'strategy.fraud.recaptcha',
	// Dynamically present Captcha overlay when backend asks for it.
	GOAL_FRAUD_STRATEGY_DYNCAPTCHA: 		'strategy.fraud.dynamiccaptcha',

	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
	/* Stat display strategy. */

	// Do not display participation stats.
	GOAL_STAT_DISPLAY_STRATEGY_NONE: 		'strategy.participatestatistics.none',
	// Display participation value.
	GOAL_STAT_DISPLAY_STRATEGY_VALUE: 		'strategy.participatestatistics.value',
	// Display participation & goal values.
	GOAL_STAT_DISPLAY_STRATEGY_VALUEGOAL: 	'strategy.participatestatistics.valuegoal',

	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
	/* Milestones periods. */
	MILESTONE_PERIOD_NONE: 					'milestone.period.none',
	MILESTONE_PERIOD_BEFORE: 				'milestone.period.before',
	MILESTONE_PERIOD_DURING: 				'milestone.period.during',
	MILESTONE_PERIOD_AFTER: 				'milestone.period.after'
};

export default Enums;
